import { render, staticRenderFns } from "./MercadolibreListItem.vue?vue&type=template&id=507324ab"
import script from "./MercadolibreListItem.vue?vue&type=script&lang=js"
export * from "./MercadolibreListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports